module.exports = __webpack_public_path__ + "img/home-step5.f1b696fb.png";